export default "__VITE_ASSET__DOUhYxWI__"